const _Looper = require("util/Looper");

const ST = {
    searchAndReplace : function(str, find, replaceWith){
        var re = new RegExp(find, 'g');
        return str.replace(re, replaceWith);
    },
    injectAround : function(str, find, beforeStr, afterStr){
        let l = find.length;
        if(l > 0){
            for(let i = 0; i < str.length; i++){
                let chars = str.substring(i, i+l);
                if(chars.toLowerCase() === find.toLowerCase()){
                    let newStr = beforeStr + chars + afterStr;
                    str = str.substring(0, i) + newStr + str.substring(i + l);
                    i = i + l + beforeStr.length + afterStr.length - 1;
                }
            }
        }
        return str;
    },
    parseHTMLString : function(html, resObj){
        _Looper.forEach(resObj, function(propName, propVal){
            html = ST.searchAndReplace(html, "{{" + propName + "}}", propVal);
        });
        return html;
    }
};
module.exports = ST;




// WEBPACK FOOTER //
// ./src/control/util/StringTools.js